export default __webpack_public_path__ + "static/media/GPA_Banner_TrackMyEnergy.2cec5a76.png";